import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
  TableRow: {
    '&.Mui-selected': {
      background: 'rgba(0, 0, 0, 0.04) !important',
    },
    '& td': {
      padding: '0px',
      borderBottom: '1px solid var(--Gray-200, #EAECF0)',
    },
  },
  FoodImage: {
    width: '24px',
    height: '24px',
    borderRadius: '3px',
    objectFit: 'cover',
  },
}));

export { useStyles };
